import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../interfaces/IReduxState";
import { IPurchaseOrder } from "../../pages/purchase-order/IPurchaseOrder";

const SyncPurchaseOrderSlice = createSlice({
  name: "SyncPurchaseOrder",
  initialState: {} as IReduxState<IPurchaseOrder[]>,
  reducers: {
    syncPurchaseOrderStart: (state, _) => {
      state.isLoading = true;
    },
    successSyncPurchaseOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureSyncPurchaseOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearSyncPurchaseOrder: (state) => {
      state.data = {};
    },
  },
});

export const {
  syncPurchaseOrderStart,
  successSyncPurchaseOrder,
  failureSyncPurchaseOrder,
  clearSyncPurchaseOrder,
} = SyncPurchaseOrderSlice.actions;

export default SyncPurchaseOrderSlice.reducer;
